import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-meteo',
  templateUrl: './meteo.component.html',
  styleUrls: ['./meteo.component.scss'],
})
export class MeteoComponent implements OnInit {
  data = null;
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    if (this.data) return;

    const request = async (url) => {
      const reponse = await fetch(url);
      return reponse.ok ? reponse.json() : Promise.reject({ error: 500 });
    };

    const getWeatherInfo = async () => {
      try {
        const url = `http://api.openweathermap.org/data/2.5/weather?q=Tunisia,Sfax&APPID=f61f9d89368d66a8f5236c64e47b9fbe&lang=fr`;
        const response = await request(url);
        this.data = response;
        this.data.date = this.getToday();
      } catch (err) {
        console.log(err);
      }
    };
    getWeatherInfo();
  }
  convertTemp(kelvin) {
    return (kelvin - 273.15).toFixed(1);
  }
  getToday() {
    const date = new Date();
    const day = date.getDate();
    const mounth = [
      'janv',
      'févr',
      'mars',
      'avril',
      'mai',
      'juin',
      'juil',
      'août',
      'sept',
      'oct',
      'nov',
      'déc',
    ][date.getMonth()];
    return day + ' ' + mounth;
  }
}
